export const headCellsWithoutPayment = [
  {
    id: 'invoiceNumber',
    numeric: false,
    disablePadding: true,
    label: 'Contractors Bills',
  },
  { id: 'contactName', numeric: true, disablePadding: false, label: 'Contact' },
  { id: 'date', numeric: true, disablePadding: false, label: 'Bill Date' },
  { id: 'subtotal', numeric: true, disablePadding: false, label: 'Subtotal' },
  { id: 'tax', numeric: true, disablePadding: false, label: 'Tax' },
  { id: 'total', numeric: true, disablePadding: false, label: 'Total' },
  {
    id: 'userTaxPercentage',
    numeric: true,
    disablePadding: false,
    label: 'Withholding %',
  },
  {
    id: 'futurePayment',
    numeric: true,
    disablePadding: false,
    label: 'Future Payment',
  },
]

export const headCellsWithPayment = [
  {
    id: 'invoiceNumber',
    numeric: false,
    disablePadding: true,
    label: 'Contractors Bills',
  },
  { id: 'contactName', numeric: true, disablePadding: false, label: 'Contact' },
  { id: 'date', numeric: true, disablePadding: false, label: 'Bill Date' },
  { id: 'subtotal', numeric: true, disablePadding: false, label: 'Subtotal' },
  { id: 'tax', numeric: true, disablePadding: false, label: 'Tax' },
  { id: 'total', numeric: true, disablePadding: false, label: 'Total' },
  {
    id: 'addedPayment',
    numeric: true,
    disablePadding: false,
    label: 'Withholding Amount',
  },
  {
    id: 'paymentDate',
    numeric: true,
    disablePadding: false,
    label: 'Payment Date',
  },
]
